var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    version: "0.0.20",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    username: "taylor+taylor@haiku.ai",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.2.1",
    title: "Green",
    type: "haiku",
    relpath: "code/green/code.js"
  },
  options: {},
  states: {
    lift: { type: "number", value: 20, edited: true },
    finished: { type: "boolean", value: false, edited: true }
  },
  eventHandlers: {
    "haiku:Green-b66ce1213827d455": {
      "timeline:Default:0": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      playGreen: {
        handler: function(component, element, target, event) {
          let frame = this.state.finished ? 90 : 1;
          this.getDefaultTimeline().gotoAndPlay(frame);
        }
      },
      "timeline:Default:177": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:89": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    },
    "haiku:Lg-ca26e974c7f85cfa": {},
    "haiku:Slot-84fe1912ba1e2103": {}
  },
  timelines: {
    Default: {
      "haiku:Green-b66ce1213827d455": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 216,
        "sizeAbsolute.y": 211,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Slot-84fe1912ba1e2103": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 107.833,
        "translation.y": 104.5,
        "sizeAbsolute.x": 93,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 89,
        "sizeMode.y": 1,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 1, edited: true },
          "517": { value: 0, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        }
      },
      "haiku:Group-a62c18a58432ce6b": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -0.333,
        "translation.y": -1
      },
      "haiku:slot-87751781f50a27af": {
        fill: "#1B2226",
        x: 0.333333333,
        y: 1,
        width: 93,
        height: 89,
        rx: 10
      },
      "haiku:Lg-ca26e974c7f85cfa": {
        "style.position": "absolute",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 125.5,
        "translation.y": 92.5,
        "sizeAbsolute.x": 41,
        "style.overflow": "visible",
        "sizeAbsolute.y": 41,
        "sizeMode.y": 1,
        "style.zIndex": 5,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-c98c6b591a399e56": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.608705357,
        "translation.x": -29,
        "translation.y": -8
      },
      "haiku:lg-6066fa61435261c0": {
        fill: "#91EB43",
        cx: 49.5,
        cy: 28.5,
        r: 20.5
      },
      "haiku:Wire-f01fea18d67e211c": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 85.5,
        "style.position": "absolute",
        "sizeAbsolute.x": 15,
        "translation.y": 115.5,
        "sizeAbsolute.y": 15,
        "sizeMode.y": 1,
        "style.zIndex": 6,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 20;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "750": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "750": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1333": { value: 1, edited: true },
          "1783": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2367": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2950": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "750": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1333": { value: 1, edited: true },
          "1783": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2367": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2950": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-253d8a4e409931bf": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.608705357,
        "translation.x": -2,
        "translation.y": -42
      },
      "haiku:wire-1339c51669b7532c": {
        stroke: "#91EB43",
        strokeWidth: 4,
        cx: 9.5,
        cy: 49.5,
        r: 7.5
      },
      "haiku:Sm-f8b6d10cf55564e2": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 106.5,
        "style.overflow": "visible",
        "sizeAbsolute.x": 29,
        "translation.y": 78.5,
        "sizeAbsolute.y": 29,
        "sizeMode.y": 1,
        "style.zIndex": 7,
        "translation.z": {
          "0": {
            value: Haiku.inject(function(lift) {
              return lift + 10;
            }, "lift"),
            edited: true
          }
        },
        opacity: {
          "0": { value: 0, edited: true },
          "633": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1217": { value: 1, edited: true },
          "1650": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1217": { value: 1, edited: true },
          "1650": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-dddcfc296c32ac86": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.608705357,
        "translation.x": -16
      },
      "haiku:sm-356547d2917bdb69": {
        fill: "#91EB43",
        cx: 30.5,
        cy: 14.5,
        r: 14.5
      },
      "haiku:Shad-Lg-57c589b5aa7582b7": {
        "style.overflow": "visible",
        "style.position": "absolute",
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 116.5,
        "translation.y": 111.5,
        "sizeAbsolute.x": 41,
        "sizeMode.x": 1,
        "sizeAbsolute.y": 41,
        "sizeMode.y": 1,
        "style.zIndex": 2,
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-01bfbb9d7f86c02f": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -29,
        "translation.y": -8
      },
      "haiku:shad_lg-6ece1c7a432e0e35": {
        fill: "#1B2226",
        cx: 49.5,
        cy: 28.5,
        r: 20.5
      },
      "haiku:Shad-Wire-3d14ac8e65c7ec05": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 76.5,
        "style.position": "absolute",
        "sizeAbsolute.x": 15,
        "translation.y": 132.5,
        "sizeAbsolute.y": 15,
        "sizeMode.y": 1,
        "style.zIndex": 3,
        opacity: {
          "0": { value: 0, edited: true },
          "750": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "750": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1333": { value: 1, edited: true },
          "1783": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2367": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2950": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "750": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1333": { value: 1, edited: true },
          "1783": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2367": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2950": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-89e587b8edd8ee9f": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -2,
        "translation.y": -42
      },
      "haiku:shad_wire-a4f8e2ab129c5267": {
        stroke: "#1B2226",
        strokeWidth: 4,
        cx: 9.5,
        cy: 49.5,
        r: 7.5
      },
      "haiku:Shad-Ms-c28b205d7e1deab1": {
        "style.overflow": "visible",
        "sizeMode.x": 1,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 97.5,
        "style.position": "absolute",
        "sizeAbsolute.x": 29,
        "translation.y": 97.5,
        "sizeAbsolute.y": 29,
        "sizeMode.y": 1,
        "style.zIndex": 4,
        opacity: {
          "0": { value: 0, edited: true },
          "633": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1217": { value: 1, edited: true },
          "1650": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "633": { value: 0.1, edited: true, curve: "easeOutBack" },
          "1217": { value: 1, edited: true },
          "1650": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2233": { value: 1.4, edited: true, curve: "easeOutBack" },
          "2817": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:Group-23ebfe38d397e38e": {
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        "translation.x": -16
      },
      "haiku:shad_ms-f23fa0a6057f2fb3": {
        fill: "#1B2226",
        cx: 30.5,
        cy: 14.5,
        r: 14.5
      }
    }
  },
  template: {
    elementName: "div",
    attributes: {
      "haiku-id": "Green-b66ce1213827d455",
      "haiku-title": "Green"
    },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Ms-c28b205d7e1deab1",
          "haiku-title": "shad_ms",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#shadow#shad_ms"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-23ebfe38d397e38e" },
            children: [
              {
                elementName: "circle",
                attributes: {
                  "haiku-id": "shad_ms-f23fa0a6057f2fb3",
                  id: "shad_ms"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Wire-3d14ac8e65c7ec05",
          "haiku-title": "shad_wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#shadow#shad_wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-89e587b8edd8ee9f" },
            children: [
              {
                elementName: "circle",
                attributes: {
                  "haiku-id": "shad_wire-a4f8e2ab129c5267",
                  id: "shad_wire"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shad-Lg-57c589b5aa7582b7",
          "haiku-title": "shad_lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#shadow#shad_lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-01bfbb9d7f86c02f" },
            children: [
              {
                elementName: "circle",
                attributes: {
                  "haiku-id": "shad_lg-6ece1c7a432e0e35",
                  id: "shad_lg"
                },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Sm-f8b6d10cf55564e2",
          "haiku-title": "sm",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#thing#sm"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-dddcfc296c32ac86" },
            children: [
              {
                elementName: "circle",
                attributes: { "haiku-id": "sm-356547d2917bdb69", id: "sm" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Wire-f01fea18d67e211c",
          "haiku-title": "wire",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#thing#wire"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-253d8a4e409931bf" },
            children: [
              {
                elementName: "circle",
                attributes: { "haiku-id": "wire-1339c51669b7532c", id: "wire" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Lg-ca26e974c7f85cfa",
          "haiku-title": "lg",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#thing#lg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-c98c6b591a399e56" },
            children: [
              {
                elementName: "circle",
                attributes: { "haiku-id": "lg-6066fa61435261c0", id: "lg" },
                children: []
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot-84fe1912ba1e2103",
          "haiku-title": "slot",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_green.svg#slot"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-a62c18a58432ce6b" },
            children: [
              {
                elementName: "rect",
                attributes: { "haiku-id": "slot-87751781f50a27af", id: "slot" },
                children: []
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/green/code.js
// module id = 520
// module chunks = 35783957827783